import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreMasterDataFilters } from './IStoredMasterDataSchemas';

interface MasterDataState {
    masterDataSchema: IStoreMasterDataFilters;
}

const initialState: MasterDataState = {
    masterDataSchema: {
        formFieldFilter: {},
    },
};

const masterDataSlice = createSlice({
    name: 'MasterDataFilters',
    initialState,
    reducers: {
        updateAuditFilters(state, action: PayloadAction<Record<string, unknown> | null>) {
            console.log("Save form field filter");
            console.dir(action.payload);
            state.masterDataSchema.formFieldFilter = action.payload || {};
        }
    },
});

export const { updateAuditFilters } = masterDataSlice.actions;
export default masterDataSlice.reducer;
